import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { AccountCommunicationEmail } from "@/api/backofficeRest/generated/model"
import { JuniferCommEmail } from "./juniferCommEmail"
import { IJuniferCommEmail } from "./juniferCommEmail.types"

export const JuniferCommEmailParser: IParser<
  IJuniferCommEmail,
  AccountCommunicationEmail
> = {
  toDomain: (data: AccountCommunicationEmail) => {
    try {
      return new JuniferCommEmail(
        data.subject,
        data.body,
        data.deliveryStatus,
        data.attachments.map(({ id, filename }) => ({ id, filename })),
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
